(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-banner"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = root => {
    root.querySelectorAll('[data-mgr-breeze]').forEach(banner => {
      if (banner.dataset.breezeReady) return;
      banner.dataset.breezeReady = 'true';
      const svg = banner.querySelector('.mgr-breeze-defs');
      const preference = matchMedia('(prefers-reduced-motion: reduce)');
      let visible = true;
      const sync = () => {
        const running = visible && !document.hidden && !preference.matches && !banner.classList.contains('mgr-motion-paused');
        banner.dataset.breezeRunning = String(running);
        if (svg && typeof svg.pauseAnimations === 'function') {
          if (running) svg.unpauseAnimations(); else svg.pauseAnimations();
        }
      };
      const observer = new MutationObserver(sync);
      observer.observe(banner, {attributes:true,attributeFilter:['class']});
      const viewport = new IntersectionObserver(entries => {visible = entries[0].isIntersecting;sync();});
      viewport.observe(banner);
      preference.addEventListener('change', sync);
      document.addEventListener('visibilitychange', sync);
      const cleanup = event => {
        if (!event.target.contains(banner)) return;
        observer.disconnect();
        viewport.disconnect();
        preference.removeEventListener('change', sync);
        document.removeEventListener('visibilitychange', sync);
        document.removeEventListener('shopify:section:unload', cleanup);
      };
      document.addEventListener('shopify:section:unload', cleanup);
      sync();
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mgr-home-main"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){
const button=event.target.closest('[data-mgr-motion]');
if(!button)return;
const area=button.closest('.mgr-screen--gift')||button.closest('.banner');
if(!area)return;
const paused=button.getAttribute('aria-pressed')!=='true';
button.setAttribute('aria-pressed',String(paused));
button.textContent=paused?'▶':'Ⅱ';
area.classList.toggle('mgr-motion-paused',paused);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mgr-shop-wardrobe"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = root => root.querySelectorAll('[data-mgr-wardrobe]').forEach(section => {
    if (section.dataset.ready) return;
    section.dataset.ready = 'true';
    const rail = section.querySelector('[data-wardrobe-rail]');
    const previous = section.querySelector('[data-wardrobe-prev]');
    const next = section.querySelector('[data-wardrobe-next]');
    const preference = matchMedia('(prefers-reduced-motion: reduce)');
    section.querySelector('[data-wardrobe-controls]').hidden = false;
    const update = () => {previous.disabled = rail.scrollLeft < 2;next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;};
    const shift = direction => rail.scrollBy({left:direction * rail.clientWidth * .72,behavior:preference.matches?'instant':'smooth'});
    previous.addEventListener('click', () => shift(-1));
    next.addEventListener('click', () => shift(1));
    rail.addEventListener('scroll', update, {passive:true});
    const resize = new ResizeObserver(update);
    resize.observe(rail);
    let start = null, dragging = false, suppressClick = false;
    rail.addEventListener('pointerdown', event => {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      start = {x:event.clientX,left:rail.scrollLeft,id:event.pointerId};
      suppressClick = false;
      dragging = false;
    });
    rail.addEventListener('pointermove', event => {
      if (!start) return;
      if (Math.abs(event.clientX - start.x) > 6 && !dragging) {dragging = true;rail.setPointerCapture(start.id);rail.dataset.dragging = 'true';}
      if (!dragging) return;
      event.preventDefault();
      rail.scrollLeft = start.left - (event.clientX - start.x);
    });
    const finish = () => {if (dragging) suppressClick = true;start = null;dragging = false;rail.dataset.dragging = 'false';update();};
    rail.addEventListener('pointerup', finish);
    rail.addEventListener('pointercancel', finish);
    rail.addEventListener('lostpointercapture', finish);
    rail.addEventListener('pointerleave', () => {if (!dragging) start = null;});
    rail.addEventListener('dragstart', event => event.preventDefault());
    rail.addEventListener('click', event => {if (suppressClick) {event.preventDefault();event.stopPropagation();suppressClick = false;}},true);
    const items = [...rail.querySelectorAll('a')];
    rail.addEventListener('keydown', event => {
      if (!['ArrowLeft','ArrowRight'].includes(event.key)) return;
      const current = items.indexOf(document.activeElement);
      if (current < 0) return;
      event.preventDefault();
      items[Math.max(0,Math.min(items.length - 1,current + (event.key === 'ArrowRight'?1:-1)))].focus();
    });
    const cleanup = event => {if (event.target.contains(section)) {resize.disconnect();document.removeEventListener('shopify:section:unload',cleanup);}};
    document.addEventListener('shopify:section:unload', cleanup);
    update();
  });
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mgr-wardrobe-depth"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = root => root.querySelectorAll('[data-depth]').forEach(section => {
    if (section.dataset.ready) return;
    section.dataset.ready = 'true';
    const stage = section.querySelector('[data-depth-stage]');
    const previous = section.querySelector('[data-depth-prev]');
    const next = section.querySelector('[data-depth-next]');
    const cards = [...section.querySelectorAll('[data-depth-card]')];
    const selectors = [...section.querySelectorAll('[data-depth-select]')];
    if (!cards.length) return;
    const preference = matchMedia('(prefers-reduced-motion: reduce)');
    const motion = section.querySelector('[data-depth-motion]');
    const motionLabel = section.querySelector('[data-depth-motion-label]');
    const liveTitle = section.querySelector('[data-depth-title]').parentElement;
    let paused = preference.matches, hovering = false, focused = false, interactedAt = 0;
    const normalize = index => ((index % cards.length) + cards.length) % cards.length;
    const wrap = distance => normalize(distance + cards.length / 2) - cards.length / 2;
    const updateMotion = () => {
      motion.hidden = false;
      section.dataset.motionPaused = String(paused || preference.matches);
      motion.setAttribute('aria-pressed',String(paused));
      motionLabel.textContent = paused ? motion.dataset.play : motion.dataset.pause;
      motion.setAttribute('aria-label',motionLabel.textContent);
      liveTitle.setAttribute('aria-live',paused || focused ? 'polite' : 'off');
    };
    let position = Math.min(6,cards.length - 1), target = position, velocity = 0, frame = 0, visible = true, start = null, moved = false, selected = -1;
    let suppressClickUntil = 0;
    let mouseAnchor = null;
    let spacing = stage.clientWidth < 750 ? 138 : 190;
    const render = () => {
      const centered = normalize(Math.round(position));
      if (selected !== centered) announce(centered);
      cards.forEach((card,index) => {
        const distance = wrap(index - position);
        const absolute = Math.abs(distance);
        card.style.setProperty('--depth-x', (distance * spacing).toFixed(2) + 'px');
        card.style.setProperty('--depth-y', (Math.min(absolute,5) * 2.5).toFixed(2) + 'px');
        card.style.setProperty('--depth-z', (85 - Math.min(absolute,6) * 105).toFixed(2) + 'px');
        card.style.setProperty('--depth-yaw', Math.max(-66,Math.min(66,distance * 27)).toFixed(2) + 'deg');
        card.style.setProperty('--depth-sway', (preference.matches ? 0 : Math.max(-7,Math.min(7,-velocity * 30 * Math.cos(index * .8)))).toFixed(2) + 'deg');
        card.style.setProperty('--depth-opacity', Math.max(0,1 - Math.max(0,absolute - 3) * .35).toFixed(3));
        card.style.zIndex = String(100 - Math.round(absolute * 10));
        card.dataset.outside = String(absolute > 5.4);
      });
    };
    const announce = index => {
      index = normalize(index);
      if (selected === index) return;
      selected = index;
      cards.forEach((card,i) => {card.dataset.selected = String(i === index);card.tabIndex = i === index ? 0 : -1;});
      selectors.forEach((button,i) => button.setAttribute('aria-pressed',String(i === index)));
      section.querySelector('[data-depth-title]').textContent = cards[index].dataset.title;
      previous.disabled = cards.length < 2;
      next.disabled = cards.length < 2;
    };
    const tick = () => {
      frame = 0;
      if (!visible || document.hidden) return;
      if (preference.matches) {position = target;velocity = 0;render();return;}
      velocity = (velocity + (target - position) * .075) * .76;
      position += velocity;
      if (Math.abs(target - position) < .0008 && Math.abs(velocity) < .0008) {position = target;velocity = 0;render();return;}
      render();
      frame = requestAnimationFrame(tick);
    };
    const wake = () => {if (!frame) frame = requestAnimationFrame(tick);};
    const choose = index => {target = position + wrap(Math.round(index) - position);wake();};
    const interact = () => {interactedAt = Date.now();};
    stage.addEventListener('pointerdown',interact);
    stage.addEventListener('keydown',interact);
    stage.addEventListener('click',interact);
    stage.addEventListener('pointerenter',event => {if(event.pointerType === 'mouse') {hovering = true;mouseAnchor = {x:event.clientX,target};}});
    stage.addEventListener('pointerleave',() => {hovering = false;mouseAnchor = null;interact();});
    stage.addEventListener('focusin',() => {focused = matchMedia('(hover:hover) and (pointer:fine)').matches;updateMotion();});
    stage.addEventListener('focusout',event => {focused = matchMedia('(hover:hover) and (pointer:fine)').matches && stage.contains(event.relatedTarget);interact();updateMotion();});
    motion.addEventListener('click',() => {paused = !paused;interact();updateMotion();});
    const preferenceChanged = () => {paused = preference.matches;updateMotion();wake();};
    preference.addEventListener('change',preferenceChanged);
    const autoTimer = setInterval(() => {
      if (!visible || document.hidden || preference.matches || paused || hovering || focused || start || Date.now() - interactedAt < 6000 || cards.length < 2) return;
      choose(Math.round(target) + 1);
    },3200);
    updateMotion();
    selectors.forEach((button,index) => button.addEventListener('click', () => choose(index)));
    previous.addEventListener('click', () => choose(Math.round(target) - 1));
    next.addEventListener('click', () => choose(Math.round(target) + 1));
    stage.addEventListener('click', event => {
      if (event.detail > 0 && Date.now() < suppressClickUntil && !event.target.closest('[data-depth-controls]')) {
        event.preventDefault();
        event.stopPropagation();
      }
    }, true);
    stage.addEventListener('pointerdown', event => {
      if (event.target.closest('[data-depth-controls]') || event.button !== 0 || !event.isPrimary) return;
      cancelAnimationFrame(frame);frame = 0;velocity = 0;
      start = {x:event.clientX,y:event.clientY,lastX:event.clientX,target:position,index:Math.round(target),id:event.pointerId};
      moved = false;
    });
    stage.addEventListener('pointermove', event => {
      if (event.pointerType === 'mouse' && !event.buttons && !start) {
        if (!mouseAnchor) mouseAnchor = {x:event.clientX,target};
        const delta = event.clientX - mouseAnchor.x;
        if (Math.abs(delta) > 3) {
          target = mouseAnchor.target - delta / spacing;
          interact();wake();
        }
        return;
      }
      if (!start || event.pointerId !== start.id) return;
      const delta = event.clientX - start.x;
      const vertical = event.clientY - start.y;
      if (!moved) {
        if (Math.abs(vertical) > 10 && Math.abs(vertical) > Math.abs(delta)) {start = null;choose(target);return;}
        if (Math.abs(delta) < 10 || Math.abs(delta) <= Math.abs(vertical)) return;
        moved = true;stage.setPointerCapture(start.id);section.dataset.dragging = 'true';
      }
      event.preventDefault();
      start.lastX = event.clientX;
      target = start.target - delta / spacing;
      position = target;velocity = 0;
      announce(Math.round(target));render();
    });
    const finish = event => {
      if (!start || event.pointerId !== start.id) return;
      const gesture = start;
      start = null;section.dataset.dragging = 'false';
      if (moved) {
        suppressClickUntil = Date.now() + 450;
        const delta = gesture.lastX - gesture.x;
        if (event.type === 'pointerup' && Math.abs(delta) >= 24 && Math.round(target) === gesture.index) target = gesture.index + (delta < 0 ? 1 : -1);
      }
      if (stage.hasPointerCapture(gesture.id)) stage.releasePointerCapture(gesture.id);
      choose(target);
    };
    window.addEventListener('pointerup', finish);
    window.addEventListener('pointercancel', finish);
    stage.addEventListener('lostpointercapture', finish);
    stage.addEventListener('pointerleave', () => {if (!moved) {start = null;choose(target);}});
    stage.addEventListener('dragstart', event => event.preventDefault());
    stage.addEventListener('keydown', event => {
      let index;
      if (event.key === 'ArrowLeft') index = Math.round(target) - 1;
      if (event.key === 'ArrowRight') index = Math.round(target) + 1;
      if (event.key === 'Home') index = 0;
      if (event.key === 'End') index = cards.length - 1;
      if (index === undefined) return;
      event.preventDefault();choose(index);cards[normalize(Math.round(target))].focus({preventScroll:true});
    });
    const resize = new ResizeObserver(() => {spacing = stage.clientWidth < 750 ? 138 : 190;render();});
    resize.observe(stage);
    const viewport = new IntersectionObserver(entries => {visible = entries[0].isIntersecting;if (visible) wake();});
    viewport.observe(stage);
    const visibility = () => {if (!document.hidden) wake();};
    document.addEventListener('visibilitychange',visibility);
    const cleanup = event => {
      if (!event.target.contains(section)) return;
      window.removeEventListener('pointerup',finish);window.removeEventListener('pointercancel',finish);cancelAnimationFrame(frame);clearInterval(autoTimer);preference.removeEventListener('change',preferenceChanged);resize.disconnect();viewport.disconnect();
      document.removeEventListener('visibilitychange',visibility);
      document.removeEventListener('shopify:section:unload',cleanup);
    };
    document.addEventListener('shopify:section:unload',cleanup);
    section.querySelector('[data-depth-controls]').hidden = false;
    announce(Math.round(target));render();section.classList.add('is-ready');
  });
  initialize(document);
  document.addEventListener('shopify:section:load',event => initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
